import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getAseanCpa = 'asean-cpa';
const postAseanCpaUrl = 'asean-cpa';
const putAseanCpa = 'asean-cpa/';
const deleteAseanCpa = 'asean-cpa/';
const putStatusTerverifikasi = 'dokumen-asean-cpa-peserta/';

// Dokumen Asean CPA
const getDokumenCpa = 'dokumen-pendukung-asean-cpa-peserta/';
const getDokumenMasterCpa = 'asean-cpa/dokumen-pendukung-peserta-dan-master/';

class AseanCpaService {
    getAseanCpa(currentPage,pageSize,filter, filterKategori) {
        return axios.get(
            API_URL + getAseanCpa + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&filterKategori=' + filterKategori,
            {
                headers: authHeader()
            });
    }

    postAseanCpa(formData) {        
        return axios
        .post(
            API_URL + postAseanCpaUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putAseanCpa(formData) {
        var headers = authHeader(); 
        formData.noSertifikat = formData.no_sertifikat
        return axios
        .put(
            API_URL + putAseanCpa + formData.id_asean_cpa, formData,
            { headers: authHeader() }
        );
    }

    deleteAseanCpa(formData) {
        var headers = authHeader();

        

        return axios
            .delete(
                API_URL + deleteAseanCpa + formData.id_asean_cpa,
                { headers: authHeader() }
            );
    }
    getDokumenCpa(id_asean_cpa){
        return axios.get(
            
            API_URL + getDokumenCpa + id_asean_cpa,
            {
                headers: authHeader()
        });
    }
    getDokumenMasterCpa(id_asean_cpa){
        return axios.get(
            
            API_URL + getDokumenMasterCpa + id_asean_cpa,
            {
                headers: authHeader()
            });
    }
    putStatusTerverifikasi(formData){
        var headers = authHeader();

        return axios
            .put(
                API_URL + putStatusTerverifikasi + formData.idDokumenAseanCpa, formData, {
                    headers: authHeader()
                }
            );
    }

}

export default new AseanCpaService();